<template>
  <div class="Info">
    <div class="NoData" v-if="TypeData == 0">
      <div class="NoDataMsg">您还未申请专业人员</div>
      <div class="NoDataBtn" @click="ApplyFor">申请</div>
    </div>
    <div class="QueryCont" v-if="TypeData == 1">
      <div class="QueryContItem" v-for="item in Data" :key="item.id">
        <!-- <div class="NoDataBtn NoDataBtn1" @click="UpdateRegistration(item.user_group_id)">更新注册</div> -->
        <!-- <div class="InfoTit">尊敬的{{ item.name }}老师：
                    <span v-if="item.status !== 'normal'" class="HuiYaunIcon">{{ item.status_info }}</span>
                    <span v-if="item.status == 'normal'" class="HuiYaunIcon">您是 {{ item.user_group_info }} 正式会员</span>
                </div> -->
        <div class="QueryContItemTit">
          <div class="iconfont icon-shujidaoru"></div>
          <div>
            {{ item.name }}
            （
            {{ item.type === 0 ? "注册:" : "更新注册:" }}
            <span v-if="item.status == 0">待提交</span>
            <span v-if="item.status == 1">待缴评审费</span>
            <span v-if="item.status == 2">推荐人待确认</span>
            <span v-if="item.status == 3">推荐人驳回返回修改</span>
            <span v-if="item.status == 4">形式待审核</span>
            <span v-if="item.status == 5">形式审查返回修改</span>
            <span v-if="item.status == 6">专家待审核</span>
            <span v-if="item.status == 7">专家驳回返回修改</span>
            <span v-if="item.status == 8">审核中</span>
            <span v-if="item.status == 9">领导审批不通过返回修改</span>
            <span v-if="item.status == 10">审核中</span>
            <span v-if="item.status == 11">公示中</span>
            <span v-if="item.status == 12">待缴注册费</span>
            <span v-if="item.status == 13">缴费完成</span>
            <span v-if="item.status == 14">领导完成不通过返回修改</span>
            <span v-if="item.status == 15">完成</span>
            ）
          </div>
          <!-- <div :class="[item == 1 ? 'ColorGreen' : item == 2 ? 'ColorYellow' : 'ColorRed']">
                        {{ item.id == 1 ? '初级' : item.id == 2 ? '中级' : '高级' }}注册心理咨询师</div> -->
          <div>{{ item.user_group_info }}</div>
          <!-- <div v-if="item.status == 'normal'"> {{ item.user_group_info }}</div> -->
          <!-- <div v-if="item.status == 'normal'">注册号:{{ item.code }}</div> -->
          <!-- <el-dropdown class="EdiBtn" trigger="click" @command="handleCommand($event,item)" >
                        <el-button type="primary">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="edit" v-if="item.type == 0" @click="GoEdit(item)">编辑
                            </el-dropdown-item>
                            <el-dropdown-item command="detail" v-if="item.type != 0" @click="GoDetail(item)">详情
                            </el-dropdown-item>
                            <el-dropdown-item command="updateRegistration">更新注册</el-dropdown-item>
                            <el-dropdown-item command="updateRegistrationRecord">更新注册记录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
          <!-- <div class="EdiBtn">
                        <el-button  v-if="item.status <= 0" size="mini"
                            @click="GoEdit(item)">编辑</el-button>
                        <el-button v-else size="mini"
                            @click="GoDetail(item)">详情</el-button>
                        <el-button  size="mini"
                            @click="UpdateRegistration(item.user_group_id)">更新注册</el-button>
                        <el-button  size="mini">支付</el-button>
                    </div> -->
          <div class="EdiBtn">
            <div
              v-if="
                item.status === 0 ||
                item.status === 3 ||
                item.status === 5 ||
                item.status === 7 ||
                item.status === 9 ||
                item.status === 14
              "
              @click="GoEdit(item)"
              style="text-decoration: underline"
            >
              编辑
            </div>
            <div
              v-if="
                item.status === 0 ||
                item.status === 3 ||
                item.status === 5 ||
                item.status === 7 ||
                item.status === 9 ||
                item.status === 14
              "
              @click="GoDetail(item)"
              style="text-decoration: underline"
            >
              详情
            </div>
            <div
              v-else
              @click="GoDetail(item)"
              style="text-decoration: underline"
            >
              详情
            </div>
            <div
              v-if="item.status === 15"
              @click="UpdateRegistration(item.user_group_id)"
              style="text-decoration: underline"
            >
              更新注册
            </div>
            <div
              v-if="item.status === 15"
              @click="DownloadCertificate(item)"
              style="text-decoration: underline"
            >
              下载证书
            </div>
            <div
              v-if="item.status == 1 || item.status == 12"
              style="text-decoration: underline"
              @click="GoToOrder"
            >
              支付
            </div>
          </div>
        </div>
        <div class="QueryContItemTit" v-if="item.status == 15">
          <div style="width: 18px"></div>

          <div class="QueryContItemDis">
            <div>注册号：{{ item.code }}</div>
            <div>
              注册期：{{
                item.passtime
                  ? item.passtime.split(" ")[0].replace(/-/g, "/")
                  : ""
              }}—{{
                new Date(item.certificate_end_time * 1000)
                  .toLocaleDateString()
                  .replace(/-/g, "/")
              }}
            </div>
          </div>
        </div>
        <div class="QueryContItemCont">
          <!-- <div class="QueryContItemImg">
                        <img src="../../assets/img/zhengShu.jpg" alt="">
                    </div> -->
          <!-- <div class="QueryContItemTxt">
                        <div class="State">
                            <div class="StateTit">注册状态</div>
                            <div class="StateTag" :class="[item.status=='hidden'?'BgBlue':(item.status=='publicity'||item.status=='normal')?'BgGreen':'BgRed']">
                                <span v-if="item.status=='hidden'">未审核</span>
                                <span v-if="item.status=='publicity'">公示中</span>
                                <span v-if="item.status=='normal'">公示完成</span>
                                <span v-if="item.status=='shenhe_hidden'">审核驳回</span>
                                <span v-if="item.status=='publicity_hidden'">公示驳回</span>
                            </div>
                        </div>
                        <div>{{item.synopsis}}</div>
                    </div> -->
        </div>
      </div>
      <div class="PageDis">
        <el-pagination
          background
          :page-sizes="[10, 20, 50]"
          layout="prev,pager,next,total,sizes"
          @size-change="SizeChange"
          @current-change="PageChange"
          :total="total"
          :current-page="page"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
    <ProfessionalProfessional ref="ref1" :peopleDetails="peopleDetails" />
  </div>
</template>

<script>
import ProfessionalProfessional from "@/components/user/ProfessionalComponents/ProfessionalProfessional";
const processStatus = {
  fenpei: "未审核",
  hidden: "未审核",
  publicity: "公示中",
  normal: "公示完成",
  publicity_hidden: "公示驳回",
  shenhe_hidden: "审核驳回",
};
export default {
  data() {
    return {
      Blon: true,
      User: "",
      Data: "",
      total: 0,
      page: 1,
      peopleDetails: {},
    };
  },
  components: {
    ProfessionalProfessional,
  },
  props: {
    TypeData: "",
  },
  mounted() {
    this.User = localStorage.getItem("User")
      ? JSON.parse(localStorage.getItem("User")).userinfo.nickname
      : "";
    this.GetData();
  },
  methods: {
    GetData() {
      this.$get("api/user/peopleSearch", {
        page: this.page,
        limit: this.SizePage,
      }).then((res) => {
        this.Data = [];
        if (res.data.code == 1) {
          this.total = res.data.data.total;
          res.data.data.data.forEach((item) => {
            item.status_info = processStatus[item.status];
            item.user_group_info = "";
            if (item.user_group.length > 0) {
              item.user_group_info = item.user_group[0].name;
            }
          });
          this.Data = res.data.data.data;
        }
      });
    },
    GoEdit(row) {
      console.log("准备编辑数据:", row);
      if (!row) {
        this.$message.error("数据不完整，请刷新页面重试");
        return;
      }

      // 如果是更新注册(type=1)，先获取详情数据，然后跳转到更新注册页面
      if (row.type === 1) {
        const params = {
          register_professional_id: row.id,
          type: 1, // 更新注册需要传递type=1参数
        };

        this.$get("api/user/peopleSearchDetails", params)
          .then((res) => {
            if (res.data.code == 1) {
              // 将详细数据存储到localStorage，供更新注册页面使用
              const detailData = res.data.data;

              // 确保user_group信息也被传递
              if (row.user_group && row.user_group.length > 0) {
                detailData.user_group = row.user_group;
              }

              // 存储详情数据，包括已有的答案信息
              localStorage.setItem(
                "UpdateRegistrationData",
                JSON.stringify(detailData),
              );

              // 跳转到更新注册页面，传递id和uid
              this.$router.push({
                path: "/updateRegistration",
                query: {
                  typeId: 1,
                  id: row.id,
                  uid: row.user_group_id,
                  mode: "edit",
                },
              });
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            console.error("获取详细数据失败:", err);
            this.$message.error("获取详细数据失败，请重试");
          });
        return;
      }

      // 如果是注册(type=0)，跳转到注册页面
      // 先获取详细数据，然后跳转
      const params = {
        register_professional_id: row.id,
      };

      this.$get("api/user/peopleSearchDetails", params)
        .then((res) => {
          if (res.data.code == 1) {
            // 将详细数据直接存储到localStorage
            const detailData = res.data.data;

            // 确保user_group信息也被传递
            if (row.user_group && row.user_group.length > 0) {
              detailData.user_group = row.user_group;
            }

            // 直接使用详情数据
            localStorage.setItem("InfoData", JSON.stringify(detailData));
            this.$router.push({ path: "/ApplyReg?type=1" });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.error("获取详细数据失败:", err);
          this.$message.error("获取详细数据失败，请重试");
        });
    },
    GoDetail(row) {
      // 兜底处理：id 可能为 null，从 user_group_id 反查
      const registerId =
        row && row.id
          ? row.id
          : (
              (this.Data || []).find(
                (i) => i.user_group_id === (row && row.user_group_id),
              ) || {}
            ).id;
      if (!registerId) {
        this.$message.error("未找到该记录ID，请刷新后重试");
        return;
      }

      const params = {
        register_professional_id: registerId,
      };

      // 如果是更新注册，添加type参数
      if (row.type === 1) {
        params.type = 1;
      }

      this.$get("api/user/peopleSearchDetails", params)
        .then((res) => {
          if (res.data.code == 1 && res.data.data) {
            this.peopleDetails = res.data.data;
            this.$refs.ref1 &&
              this.$refs.ref1.OpenReviewBlon &&
              this.$refs.ref1.OpenReviewBlon();
          } else {
            this.$message.error(res.data.msg || "详情数据为空");
          }
        })
        .catch((err) => {
          console.error("获取详情失败:", err);
          this.$message.error("获取详情失败，请重试");
        });
    },
    ApplyFor() {
      this.$router.push({ path: "/ApplyReg?type=1" });
    },
    UpdateRegistration(uid) {
      this.$router.push({
        path: "/updateRegistration",
        query: {
          typeId: 1,
          id: (this.Data.find((item) => item.user_group_id === uid) || {}).id,
          uid: uid,
        },
      });
    },
    updateRegistrationRecord() {
      this.$router.push({ path: "/updateRegistrationRecord" });
    },
    SizeChange(val) {
      this.SizePage = val;
      this.GetData();
    },
    PageChange(val) {
      this.page = val;
      this.GetData();
    },
    handleCommand(command, row) {
      switch (command) {
        case "edit":
          this.GoEdit(row);
          break;
        case "detail":
          this.GoDetail(row);
          break;
        case "updateRegistration":
          this.UpdateRegistration();
          break;
        case "updateRegistrationRecord":
          this.updateRegistrationRecord();
          break;
        default:
          console.error("未知命令:", command);
      }
    },
    GoToOrder() {
      this.$emit("TogglePage", 5);
    },
    DownloadCertificate(row) {
      if (!row) {
        this.$message.error("数据不完整，请刷新后重试");
        return;
      }

      // cid: 1 初级/默认，2 中级，3 高级
      // type: 1 督导师，2 心理咨询师
      const userGroupId = parseInt(row.user_group_id, 10);
      let cid = 1;
      let type = 2;
      if (userGroupId === 1) {
        cid = 1;
        type = 2;
      } else if (userGroupId === 2) {
        cid = 2;
        type = 2;
      } else if (userGroupId === 3) {
        cid = 3;
        type = 2;
      } else if (userGroupId === 4) {
        cid = 1;
        type = 1;
      }

      const code = row.code || "";
      const date = row.passtime ? row.passtime.split(" ")[0] : "";

      const fd = new FormData();
      fd.append("cid", cid);
      fd.append("type", type);
      fd.append("code", code);
      fd.append("date", date);

      this.$post("api/Certificate/getMyCertificate", fd)
        .then((res) => {
          if (res.data && res.data.code == 1) {
            const url =
              res &&
              res.data &&
              res.data.data &&
              (res.data.data.uploadUrl ||
                (res.data.data.raw && res.data.data.raw.path_url));
            if (!url) {
              this.$message.error("证书下载链接为空，请稍后重试");
              return;
            }
            this.DownloadByUrl(url);
          } else {
            this.$message.error((res.data && res.data.msg) || "获取证书失败");
          }
        })
        .catch((err) => {
          console.error("getMyCertificate error:", err);
          this.$message.error("获取证书失败，请重试");
        });
    },
    // 尽量使用 blob 下载，避免浏览器直接预览并跳到 PDF 标签页
    DownloadByUrl(url) {
      if (!url) return;

      const fileName = (() => {
        try {
          const path = url.split("?")[0] || "";
          const last = path.split("/").pop() || "certificate.pdf";
          return decodeURIComponent(last);
        } catch (e) {
          return "certificate.pdf";
        }
      })();

      try {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200 && xhr.response) {
            const objectUrl = window.URL.createObjectURL(xhr.response);
            const a = document.createElement("a");
            a.href = objectUrl;
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(objectUrl);
          } else {
            this.DownloadByIframe(url);
          }
        };
        xhr.onerror = () => {
          this.DownloadByIframe(url);
        };
        xhr.send();
      } catch (e) {
        this.DownloadByIframe(url);
      }
    },
    DownloadByIframe(url) {
      // 兜底：通过隐藏 iframe 触发下载，避免当前页跳转
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(() => {
        if (iframe && iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }, 30000);
    },
  },
};
</script>
<style scoped>
.InfoTit {
  padding: 10px 0;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}

.HuiYaunIcon {
  padding: 5px 10px;
  background: #e3faff;
  font-weight: 400;
  font-size: 16px;
  color: #0385eb;
}

.NoData {
  margin: 0 auto;
  text-align: center;
}

.NoDataMsg {
  padding: 60px 0;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  text-align: center;
}

.NoDataBtn {
  cursor: pointer;
  width: 90px;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  padding: 7px 15px;
  border-radius: 20px;
  background: #0385eb;
  margin: 0 auto;
}

.QueryContItemTit {
  padding: 10px;
  color: #fff;
  font-size: 16px;
  background: #0286eb;
  display: flex;
  align-items: center;
  position: relative;
}

.QueryContItemTit div {
  margin-right: 20px;
}

.QueryContItemTit div:last-child {
  margin-right: 0;
}

.EdiBtn {
  display: flex;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 10px;
  cursor: pointer;
}

.QueryContItemCont {
  padding: 10px 0 20px 0;
  display: flex;
}

.QueryContItemImg {
  width: 100%;
}

.State {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.StateTit {
  font-weight: 400;
  font-size: 16px;
  color: #999;
}

.StateTag {
  margin-left: 10px;
  padding: 3px 15px;
}

.StateTag.BgBlue {
  background: #e8f3fc;
  border: 1px solid #9cc1f1;
  color: #3a83e4;
}

.StateTag.BgGreen {
  background: #e4f9ef;
  border: 1px solid #a4eaca;
  color: #49d696;
}

.StateTag.BgRed {
  background: #fac2c2;
  border: 1px solid #d51938;
  color: #d51938;
}

.QueryContItemTxt {
  flex: 1;
  line-height: 30px;
  font-size: 16px;
  color: #737373;
}
.QueryContItemDis {
  display: flex;
  align-items: center;
}
.PageDis {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.QueryCont .NoDataBtn1 {
  margin: 0;
  margin-bottom: 10px;
  text-align: center;
  font-size: 16px;
}

@media only screen and (max-width: 550px) {
  .QueryContItemTit {
    justify-content: space-between;
  }

  .QueryContItemTit div {
    margin: 0;
  }

  .QueryContItemDis {
    display: block;
  }
}
::v-deep .QueryContItemTit .el-button {
  padding: 8px 16px;
  background-color: #fff;
}
::v-deep .QueryContItemTit .el-button span {
  color: #000000;
}
</style>
